import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20coral%20gradient%20flowing%20organic%20shapes%20with%20soft%20geometric%20elements%2C%20modern%20creative%20studio%20atmosphere%2C%20digital%20art%20abstract%20composition%2C%20elegant%20flowing%20lines%2C%20warm%20ambient%20glow%2C%20cinematic%20depth%20of%20field%2C%20artistic%20minimal%20style%2C%20no%20text%20no%20people&width=1800&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-sm text-white/90">萝卜视频 2.0 全新发布</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            智能AI视频创作
            <br />
            <span className="text-primary-300">让创意变为现实</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            萝卜视频是一款专为创作者打造的智能视频工具，支持一键生成、剪辑、配音与字幕，
            让每个人都能轻松制作专业级视频内容。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="px-8 py-3.5 rounded-md bg-primary-500 text-white text-base font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              免费开始使用
            </a>
            <Link
              to="/articles/beginner-guide-ai-video-creation"
              className="px-8 py-3.5 rounded-md bg-white/15 backdrop-blur-sm text-white text-base font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer border border-white/20"
            >
              查看教程
            </Link>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 text-white/60 text-sm">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-accent-400 text-lg"></i>
              <span>无需下载</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-accent-400 text-lg"></i>
              <span>AI智能剪辑</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-accent-400 text-lg"></i>
              <span>免费试用</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}